// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { envMode, envModes } from '$config/env'
import { isAndroid } from '$func/environmentInfo'
import { showInstallPWAPromptSnackbar } from '$comp/snackbars'

/**
 * The BeforeInstallPromptEvent is fired at the Window.onbeforeinstallprompt handler
 * before a user is prompted to "install" a web site to a home screen on mobile.
 *
 */
interface BeforeInstallPromptEvent extends Event {
  /**
   * Returns an array of DOMString items containing the platforms on which the event was dispatched.
   * This is provided for user agents that want to present a choice of versions to the user such as,
   * for example, "web" or "play" which would allow the user to chose between a web version or
   * an Android version.
   */
  readonly platforms: Array<string>

  /**
   * Returns a Promise that resolves to a DOMString containing either "accepted" or "dismissed".
   */
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed'
    platform: string
  }>

  /**
   * Allows a developer to show the install prompt at a time of their own choosing.
   * This method returns a Promise.
   */
  prompt(): Promise<{
    outcome: 'accepted' | 'dismissed'
    platform: string
  } | void>
}

let currentState: 'dismissed' | 'accepted' | 'init' = 'init'
if (envMode !== envModes.DEVELOPMENT && !isAndroid)
  window.addEventListener(
    'beforeinstallprompt',
    (e: BeforeInstallPromptEvent) => {
      if (currentState === 'init')
        showInstallPWAPromptSnackbar(() => {
          e.prompt()
          e.userChoice.then(res => {
            currentState = res.outcome
          })
        })
    },
  )

if (
  envMode !== envModes.DEVELOPMENT &&
  isAndroid &&
  // @ts-ignore
  import.meta.env.VITE_PREVENT_INSTALL_PWA === 'true'
)
  window.addEventListener(
    'beforeinstallprompt',
    (e: BeforeInstallPromptEvent) => {
      e.preventDefault()
    },
  )
